export default __webpack_public_path__ + "static/media/package_15.5a7f1a27.png";